import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { get, sample } from 'lodash';
import { GoogleMapUrl, Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import LightBox from '@bd/bdui-lightbox';
import { FavoriteToggle, FavoriteEdit } from '../../components/Favorites';
import { colors } from '../../components/../styles';
import icons from '../../components/IconsList';
import VideoModal from '../../components/VideoModal';

const styles = css`
  width: 100%;
  max-width: 300px;
  margin: 5px;
  transition: all .3s ease-out;
  @media(min-width: 992px) {
    max-width: 380px;
  }
  &:hover {
    background-color: #f1f1f1;
    @media(min-width: 992px) {
      box-shadow: rgba(0, 0, 0, 0.2) 0px 15px 20px 0px;
      transform: scale(1.005);
    }
  }
  .CommunityHomeCard_topWrapper {
    .CommunityHomeCard_imageWrapper {
      width: 100%;
      .CommunityHomeCard_image  {
        height: 194px;
        object-fit: cover;
        width: 100%;
        @media(min-width: 992px) {
          height: 213px;
        }
      }
    }
  }
  .CommunityHomeCard_content {
    padding: 15px 0;
    border-bottom: 1px solid #DADADA;
  }
  .CommunityHomeCard_address {
    font-weight: 900;
    font-size: 19px;
    color: #000000;
    letter-spacing: -0.45px;
    span {
      font-size: 12px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
    &:hover {
      color: ${colors.color1};
    }
  }
  .CommunityHomeCard_status {
    background-color: rgb(251, 245, 235);
    font-weight: 700;
    font-size: 12px;
    color: #171717;
    letter-spacing: 0;
  }
  .CommunityHomeCard_details {
    font-size: 13px;
    color: #171717;
    letter-spacing: 0;
    line-height: 20px;
  }
  b {
    font-weight: 700;
  }
  .CommunityHomeCard_bottomWrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .CommunityHomeCard_list {
    flex: 1;
    li {
      padding: 0 0 0 20px;
      font-size: 12px;
      color: #171717;
      letter-spacing: 0;
      background-repeat: no-repeat;
      background-position: left center;
      display: flex;
      align-items: center;
      @media(min-width: 310px) {
        font-size: 13px;
      }
      @media(min-width: 400px) {
        padding: 0 20px;
      }
      & + li {
        margin: 0 0 0 10px;
      }
    }
  }
  .CommunityHomeCard_btnsWrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 10px 0 0;
    @media(min-width: 992px) {
      margin: 0;
      width: max-content;
    }
  }
  .CommunityHomeCard_bottomIcons {
    padding: 10px 10px 10px 0;
    justify-content: flex-end;
  }
  .CommunityHomeCard_arrow {
    margin: 0;
  }
  .VideoModal_wrapper {
    height: 31px;
    width: 43px;
    background-color: ${colors.color1};
    margin-right: 5px;
  }
  .VideoModal_btn {
    height: 100%;
    width: 100%;
    display: flex;
  }
  .CommunityHomeCard_tour {
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
  }
  .CommunityHomeCard_photosList {
    width: 74px;
    background-color: rgba(0, 0, 0, 0.82);
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-image: url(${get(icons, 'expend')});
    background-position: 10px center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .CommunityHomeCard_photosListBtn {
    height: 31px;
    width: 37px;
    font-weight: 700;
    font-size: 12px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 12px;
    background-color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      @media(min-width: 992px) {
        opacity: 0.8;
      }
    }
  }
  /* Favorite Styling */

    .FavoriteCardWrap {
      display: flex;
      position: relative;

      .FavoriteToggle {
        width: 30px;
        background: url(/images/icons/favorites-heart-outline.svg);
        height: 30px;
        background-repeat: no-repeat;
        transition: all .25s ease;
        background-position: right;
      }
      .FavoriteToggle-active {
        background: url(/images/icons/favorites-heart-full.svg);
      }
      .Favorite_circle {
        width:40px;
        height:40px;
        background:rgba(0,0,0,.4);
        padding: 4px;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
        border-radius:50%;
        display:flex;
        flex-flow:column nowrap;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        &-edit {
          right: 55px;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .FavoriteEditWrap {
      padding:4px;
      text-align: left;
      textarea {
        background:#333;
        border:1px solid black;
        border-radius: 0;
        margin-bottom:4px;
        width:100%;
        height:50px;
        color:white;
      }
    }
    .CommunityHomeCard_statusSold {
      color: red !important;
      font-weight: 700;
    }
    .CommunityHomeCard_statusOther {
      color: ${colors.color1} !important;
      font-weight: 700;
    }
`;

function CommunityHomeCard({ home, widget, community, plan, favorite, className }) {
  const comingSoon = get(widget, 'default_image.contentUrl');
  const cardId = `card-${home._id}`;
  const oneSchool = sample(get(community, 'schools'));
  let homePrice = get(home, 'price') > 0 ? numeral(get(home, 'price')).format('$0,0') : 'Call for Pricing';
  homePrice = get(home, 'custom_price_display') ? get(home, 'custom_price_display') : homePrice;
  return (
    <div className={`${className} ${styles} CommunityHomeCard_wrapper`} role="group" aria-labelledby={cardId}>
      <div className="CommunityHomeCard_topWrapper">
        <Link name="home-detail" home={home} className="CommunityHomeCard_imageWrapper FavoriteCardWrap">
          {
            get(home, 'photos[0].contentUrl') &&
            <Image
              className="CommunityHomeCard_image"
              src={get(home, 'photos[0].contentUrl')}
              alt={get(home, 'photos[0].name', '')}
              width={450}
              height={450}
            />
          }
          {
            !get(home, 'photos[0].contentUrl') &&
            <img
              className="CommunityHomeCard_image"
              src={comingSoon}
              alt={get(home, 'photos[0].name', '')}
            />
          }
          <div className="Favorite_circle">
            <FavoriteToggle home={home} />
          </div>
        </Link>
        <div className="CommunityHomeCard_content">
          <hgroup className="d-flex justify-content-between py-2 px-lg-3">
            <Link name="home-detail" home={home} className="d-flex flex-column CommunityHomeCard_address">
              {get(home, 'address.streetAddress')}
              <span>{`${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')}`}</span>
            </Link>
            <a href={GoogleMapUrl(home)} className="col-2 px-0 d-flex justify-content-center" target="_blank" rel="noopener noreferrer">
              <img src={get(icons, 'mapPin')} alt="Card Map Pin" height="25px" width="auto" />
            </a>
          </hgroup>
          {
            get(home, 'status') &&
            <div className={`CommunityHomeCard_status py-2 px-3 ${get(home, 'status') === 'Sold' ? 'CommunityHomeCard_statusSold' : 'CommunityHomeCard_statusOther'}`}>
              {`Status: ${get(home, 'status')}`}
            </div>
          }
          <div className="pt-2 px-lg-3 CommunityHomeCard_details">
            <b>Price</b>&nbsp;{homePrice}
          </div>
          {
            plan &&
            <div className="py-1 px-lg-3 CommunityHomeCard_details">
              <b>Floor Plan <Link name="plan-detail" plan={plan}>{get(plan, 'name')}</Link></b>
            </div>
          }
          {
            get(home, 'mls') &&
            <div className="pb-1 px-lg-3 CommunityHomeCard_details">
              <b>MLS#</b> {get(home, 'mls')}
            </div>
          }
          {
            oneSchool &&
            <div className="px-lg-3 CommunityHomeCard_details">
              <b>School</b> {get(oneSchool, 'name', '').split(' ').slice(0, -1).join(' ')}
            </div>
          }
        </div>
      </div>
      <div className="CommunityHomeCard_bottomWrapper py-2 px-lg-2">
        <ul className="list-unstyled d-flex CommunityHomeCard_list m-0">
          <li className="CommunityHomeCard_listItem" style={{ backgroundImage: `url(${icons.beds})` }}>
            <b>{get(home, 'beds')}</b> Beds
          </li>
          <li className="CommunityHomeCard_listItem" style={{ backgroundImage: `url(${icons.baths})` }}>
            <b>{get(home, 'bathsFull')}{get(home, 'bathsHalf', 0) > 0 ? '.5' : ''}</b> Baths
          </li>
          <li className="CommunityHomeCard_listItem" style={{ backgroundImage: `url(${icons.sqft})` }}>
            <b>{numeral(home.sqft).format('0,0')}</b> SQFT
          </li>
        </ul>
      </div>
      <div className="CommunityHomeCard_bottomIcons d-flex m-1">
        <Link name="home-detail" home={home} className="order-lg-1 CommunityHomeCard_arrow"><img src={get(icons, 'arrowRightShort')} alt={get(home, 'address.streetAddress')} /></Link>
        <div className="CommunityHomeCard_btnsWrapper mr-lg-3 mt-3 mt-lg-0">
          {
            get(home, 'tourUrl') &&
            <VideoModal tour={get(home, 'tourUrl')}><span className="CommunityHomeCard_tour" style={{ backgroundImage: `url(${get(icons, 'tour')})` }} /></VideoModal>
          }
          {
            get(home, 'photos').length > 1 &&
            <LightBox
              items={get(home, 'photos', [])}
              button={(
                <div className="CommunityHomeCard_photosList"><span className="CommunityHomeCard_photosListBtn">{`+${get(home, 'photos').length - 1}`}</span></div>
              )}
            />
          }
        </div>
      </div>
      {
        favorite &&
        <div className="FavoriteEditWrap">
          <FavoriteEdit favorite={favorite} />
        </div>
      }
    </div>
  );
}

CommunityHomeCard.propTypes = {
  home: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
  community: PropTypes.object,
  plan: PropTypes.object,
  favorite: PropTypes.object,
  className: PropTypes.string,
};

CommunityHomeCard.defaultProps = {
  className: '',
  community: undefined,
  plan: undefined,
  favorite: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
    widget: 'default_image',
  },
  {
    required: {
      home: true,
      widget: true,
    },
  },
)(CommunityHomeCard);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityHomeCard.js